import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { highlightKeys } from './highlightKeys';
import { IHighlight } from './useQueryHighlights';
import { useTranslation } from 'react-i18next';

export interface ICreateHighlightParams {
  title: string;
  description: string;
}

export const createHighlight = async (
  params: ICreateHighlightParams
): Promise<IHighlight> => {
  const response = await EXPRESS_API.post(`/highlights`, params);
  return response.data;
};

export const useCreateHighlightMutation = (onSuccess?: () => void) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  return useMutation(createHighlight, {
    onSuccess: async () => {
      await queryClient.invalidateQueries(highlightKeys.all());
      onSuccess?.();
      successToast({
        title: t(`Highlight has been successfully created!`),
      });
    },
    onError: error =>
      showError(
        error || t(`An error occurred while trying to create the highlight.`)
      ),
  });
};
